import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { APP_SERVICE } from '../constants'
import useDevices from '../hooks/useDevices'
import paths from '../routes/paths'
import { isOrderAtRestaurant } from '../utils'


const ValidContext = () => {
    const { isMobile } = useDevices()
    const history = useHistory()

    useEffect(() => {
        isOrderAtRestaurant(APP_SERVICE) &&
            !isMobile &&
            history.push(paths.unSupport)
    }, [isMobile])

    return null
}

export default ValidContext
